import React from 'react';


const LiveBtn = (props) => {
    const { 
        ...restProps 
    } = props;



    return (
        <div className="liveBtn">
            <svg width="83" height="37" viewBox="0 0 83 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="83" height="37" rx="4" fill="#E4002B"/>
                <circle className="liveBtn__dot" cx="22" cy="18.5" r="5.5" stroke="white" strokeWidth="3"/>
                <path d="M37.912 13.264V21.76H41.968V24H35.352V13.264H37.912ZM43.7114 24V13.264H46.2714V24H43.7114ZM52.6806 21.16L55.0006 13.264H57.6726L54.1206 24H51.4166L47.9286 13.264H50.6326L52.9046 21.16H52.6806ZM59.2891 24V13.264H66.4651V15.48H61.8491V17.544H66.1771V19.768H61.8491V21.76H66.4651V24H59.2891Z" fill="white"/>
            </svg>
        </div>
    );
}



/**
 * Export
 */
export { LiveBtn };